import * as React from 'react';
import { useImperativeHandle } from 'react';
import { Typography, List, ListItem, ListItemText, ListItemIcon, Button, ListItemButton } from '@mui/material';
import { Box, Paper, Divider } from '@mui/material';
import VerticalHamburgerMenu from '../../common/controls/VerticalHamburgerMenu';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import WaiverForm from '../forms/WaiverForm';
import { useWaivers } from '../../../hooks/waivers/useWaivers';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { removeZeroDecimals } from '../../../utils/removeZeroDecimals';
import VitalsView from '../modals/VitalsView';
import { useDeleteWaiver } from '../../../hooks/waivers/useDeleteWaiver';
import { getWaiverById } from '../../../api/historyService';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';

export default function WaiversListItems({ setListEmpty, setDoneLoading = null, history = null, historyEntry = null, pet = null, mode='history', ref }) {
  const { t } = useTranslation('common');
  const { showSnackbar } = useSnackbar();

  const  {waivers, loading, loadMore, searchFunction, resetParent } = useWaivers(history?.id, historyEntry?.id, pet?.id, mode);

  const [selectedWaiver, setSelectedWaiver] = React.useState(null);

  const [waiverFormOpen, setWaiverFormOpen] = React.useState(false);
  const [waiverViewOpen, setWaiverViewOpen] = React.useState(false);

  const onWaiverSaveSuccess = async (updatedRecord) => {
    const updatedWaiver = await getWaiverById(updatedRecord.id);
    setSelectedWaiver(updatedWaiver);
    resetParent();
  };

  const handleWaiverCreate = () => {
    setSelectedWaiver(null);
    setWaiverFormOpen(true);
  };
  // Expose the function to parent
  useImperativeHandle(ref, () => ({
    handleWaiverCreate
  }));

  const handleWaiverEdit = (vital) => {
    setSelectedWaiver(vital);
    setWaiverFormOpen(true);
  };
  const handleWaiverDelete = async (waiver) => {
    try {
      await remove(waiver.id);
    } catch (err) {
      showSnackbar(t('waivers.messages.delete_fail'), "error");
    }
    
  };
  const onDeleteWaiverSuccess = () => {
    resetParent();
    showSnackbar(t('waivers.messages.delete_success'), "success");
  };
  const { remove } = useDeleteWaiver(onDeleteWaiverSuccess);

  const handleListItemEdit = (waiver) => {
    handleWaiverEdit(waiver);
  };

  const handleListItemDelete = (waiver) => {
    handleWaiverDelete(waiver);
  };

  React.useEffect(() => {
    if (waivers.data.length !== 0)
    {
      setListEmpty(false);
    }
  }, [waivers]);

  React.useEffect(() => {
    if (!loading)
    {
      if (setDoneLoading) setDoneLoading(true);
    }
  }, [loading]);

  return (
    <>
      {loading ? (
        <></>
      ) : (
      waivers?.data.map((waiver) => (
        <ListItem 
            key={"waiver" + waiver.id}
            sx={{ py: 0 }}
            alignItems="flex-start"
            secondaryAction={
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <VerticalHamburgerMenu
                    options={[
                        { 
                            id: 1, 
                            name: 'Edit',
                            callback: () => handleListItemEdit(waiver)
                        },
                        {
                            id: 2,
                            name: 'Delete',
                            callback: () => handleListItemDelete(waiver),
                            confirmMessage: t('waivers.messages.delete_confirm', { name: waiver.name })
                        }
                    ]}
                    />
                </Box>
            }
        >
            <ListItemButton 
              sx={{ py: 0 }} 
              onClick={() => handleListItemEdit(waiver)}
            >
            <ListItemIcon>
              <EditNoteIcon color='primary' />
            </ListItemIcon>
            <ListItemText
              primary={
                <>
                <Typography variant="body2" sx={{ maxWidth: '90%' }}>
                  {`${waiver.name}`}
                </Typography>
                </>
              }
            secondary={formatToLocalDateTime(waiver.updatedAt)}
            />
            </ListItemButton>
        </ListItem>
      )))}
      <WaiverForm
        waiver={selectedWaiver}
        successCallback={onWaiverSaveSuccess}
        history={history}
        historyEntry={historyEntry}
        pet={pet} 
        open={waiverFormOpen}
        onClose={() => setWaiverFormOpen(false)}
      />
      {/* <VitalsView 
        handleEdit={handleVitalsEdit}
        vitals={selectedVital}
        open={vitalsViewOpen}
        onClose={() => setVitalsViewOpen(false)}
      /> */}
    </>
  );
}